import React, { useEffect, useRef, useState } from "react";
import Image1 from '../assets/image1.png';
import Image2 from '../assets/image2.png';
import Image3 from '../assets/image3.png';
import Image4 from '../assets/image4.png';
import Image5 from '../assets/image5.png';
import Image6 from '../assets/image6.png';
import "../style.css";

export default function Howtoplay() {
   useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const videoRef = useRef(null);
  const [currentStep, setCurrentStep] = useState(0);
  const totalSteps = 6;
  const classicV = [];

  const [autoCycle, setAutoCycle] = useState(true);
  const cycleTimeout = useRef();

  // Auto-cycle effect
  useEffect(() => {
    if (!autoCycle) return;
    function nextStep() {
      setCurrentStep((prev) => (prev + 1) % totalSteps);
    }
    cycleTimeout.current = setTimeout(nextStep, 20000);
    return () => clearTimeout(cycleTimeout.current);
  }, [currentStep, autoCycle]);

  // Play video when currentStep changes
  useEffect(() => {
    if (videoRef.current) {
      const nextSrc = classicV[currentStep];
      videoRef.current.src = nextSrc;
      videoRef.current.onloadeddata = () => {
        videoRef.current.play().catch((err) => {
          console.error("Video play failed:", err);
        });
      };
      videoRef.current.load();
    }
  }, [currentStep]);

  // Click handler for steps
  const handleStepClick = (idx) => {
    setCurrentStep(idx);
    setAutoCycle(false);
    // Restart auto-cycle after a delay
    setTimeout(() => setAutoCycle(true), 20000);
  };

  const stepsData = [
    {
      title: "01 - Signup & Login",
      description: "Register to create your profile & log in details."
    },
    {
      title: "02 - Choose to play the Round with 1 or 2 Picks",
      description: "Decide if you are joining a New Round with 1 or 2 picks. Each player can play a maximum of 2 picks per Round."
    },
    {
      title: "03 - Buy or Redeem Tokens",
      description: "Tokens are needed to play in each Round. A minimum of 1 token is required per Pick."
    },
    {
      title: "04 - Pick your Team",
      description: "Assign your picks to teams from the upcoming match week. You progress if your team wins, if not you are eliminated."
    },
    {
      title: "05 - Stay Alive",
      description: "While progressing in any Round, you cannot pick the same teams from previous weeks."
    },
    {
      title: "06 - Win the Prize",
      description: "When there are 5 or fewer players, you will get a chance to vote on splitting the jackpot, otherwise keep playing on to be the last man standing."
    }
  ];

  const stepImages = [
   Image1,
   Image2,
   Image3,
   Image4,
   Image5,
   Image6
  ];

  return (
    <div className="container mx-auto px-4 py-16">
      
      <div className="flex flex-col lg:flex-row items-stretch justify-between max-w-7xl mx-auto">
        {/* Left column - first 3 steps */}
        <div className="w-full lg:w-[30%] flex flex-col space-y-8 mb-8 lg:mb-0">
          {stepsData.slice(0, 3).map((step, index) => (
            <div 
              key={index}
              className={`relative p-6 cursor-pointer transition-all duration-300 h-full
                ${currentStep === index ? 'bg-[#F6FAFF]' : 'bg-white hover:bg-gray-50'}`}
              onClick={() => handleStepClick(index)}
            >
              <h3 className="text-lg font-semibold font-archivo mb-3">{step.title}</h3>
              <p className="text-gray-700 font-inter text-sm md:text-base">{step.description}</p>
              {/* Only bottom border for active step */}
              <div className={`absolute inset-x-0 bottom-0 left-0 h-1 bg-[#007FFF] transition-all duration-200 ease-linear 
                ${currentStep === index ? 'w-full' : 'w-0'}`}
              ></div>
            </div>
          ))}
        </div>

        {/* Middle column - Phone display */}
        <div className="w-full lg:w-[40%] flex items-center justify-center px-4 lg:px-8 mb-8 lg:mb-0 relative">
          <div className="relative w-full max-w-[320px] mx-auto">
            <img 
              src={stepImages[currentStep]} 
              alt={`Step ${currentStep + 1}`} 
              className="w-full h-auto"
            />
          </div>
        </div>

        {/* Right column - last 3 steps */}
        <div className="w-full lg:w-[30%] flex flex-col space-y-8">
          {stepsData.slice(3, 6).map((step, index) => (
            <div 
              key={index + 3}
              className={`relative p-6 cursor-pointer transition-all duration-300 h-full
                ${currentStep === index + 3 ? 'bg-[#F6FAFF]' : 'bg-white hover:bg-gray-50'}`}
              onClick={() => handleStepClick(index + 3)}
            >
              <h3 className="text-lg font-semibold font-archivo mb-3">{step.title}</h3>
              <p className="text-gray-700 font-inter text-sm md:text-base">{step.description}</p>
              {/* Only bottom border for active step */}
              <div className={`absolute inset-x-0 bottom-0 left-0 h-1 bg-[#007FFF] transition-all duration-200 ease-linear 
                ${currentStep === index + 3 ? 'w-full' : 'w-0'}`}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}